import React from "react";
import PropTypes from "prop-types";

export default function Composer({
  value = "",
  onChange,
  onSend,
  disabled = false
}) {
  return (
    <form
      onSubmit={onSend}
      style={{
        display: "flex",
        gap: 12,
        padding: 20,
        borderTop: "1px solid #E5ECE8"
      }}
    >
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        rows={3}
        disabled={disabled}
        placeholder="Ask Ecovanta Copilot anything..."
        style={{
          flex: 1,
          borderRadius: 14,
          border: "1px solid #D4E0DC",
          padding: 14,
          font: "inherit"
        }}
      />

      <button
        className="copilot-btn-primary"
        disabled={disabled || !value.trim()}
      >
        Send
      </button>
    </form>
  );
}

Composer.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSend: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};